import {
    Trophy,
    Sparkles,
    Clock3,
    User,
    Users, CheckCircle
} from "lucide-react";
import dayjs from "dayjs";
import { theme } from "../../gamification/_section/RewardSystem";
import React from "react";
import {CommonIcon} from "../../../../core/components/icon";
import RenderIf from "../../../../core/components/render-if";

export const AwardRaceCard = ({ item }) => {

    const award = item?.award;

    const isUser = award?.type === "user";

    const user = item?.user;
    const team = item?.team;

    const name = isUser
        ? `${user?.firstName ?? ""} ${user?.lastName ?? ""}`.trim()
        : team?.name;

    const avatar = user?.avatarDetail?.url;

    const awardImage = award?.fileDetail?.url;

    return (
        <div
            className="relative rounded-3xl overflow-hidden p-5 transition-all duration-300"
            style={{
                background: "rgba(255,255,255,.05)",
                backdropFilter: "blur(12px)",
                border: `1px solid ${theme.light}22`
            }}
        >
            <div className="flex gap-4">

                {/* Avatar */}
                <div
                    className="w-16 h-16 rounded-full overflow-hidden shrink-0 flex items-center justify-center"
                    style={{
                        border: `2px solid ${theme.accent}`,
                        background: `${theme.primary}33`
                    }}
                >
                    {isUser && avatar ? (
                        <img
                            src={avatar}
                            alt={name}
                            className="w-full h-full object-cover"
                        />
                    ) : isUser ? (
                        <User
                            color={theme.light}
                            size={28}
                        />
                    ) : (
                        <Users
                            color={theme.light}
                            size={28}
                        />
                    )}
                </div>

                <div className="flex-1">

                    {/* Header */}
                    <div className="flex justify-between items-start">

                        <div>

                            <div
                                className="font-bold text-white text-lg"
                            >
                                {name}
                            </div>

                            <div
                                className="text-xs mt-1"
                                style={{
                                    color: theme.light
                                }}
                            >
                                {new Date(item?.createdAt).toLocaleDateString("fa-IR")}
                            </div>

                        </div>
                        <div className={'flex flex-wrap gap-1'}>
                            <RenderIf cond={item?.payedPrerequisites}>
                                <div className="flex flex-wrap items-center justify-center gap-2 px-3 py-1 rounded-full"
                                     style={{
                                         background: `${theme.primary}66`,
                                         color: theme.light
                                     }}>
                                    {item?.payedPrerequisites?.map((prerequisite, index) => (
                                        <span key={index + '-' + prerequisite?.award?.id + '-' +  prerequisite?.id} className={'flex gap-1 items-center text-sm'}>
                                            <span className={'text-xs'}>{prerequisite?.award?.prefix?.title}</span>
                                            {prerequisite?.award?.title}
                                            <RenderIf cond={item?.payedPrerequisites?.length > index + 1}>
                                            ,
                                        </RenderIf>
                                    </span>
                                    ))}
                                </div>
                            </RenderIf>
                            <RenderIf cond={item?.payedExperience}>
                                <div
                                    className="px-3 py-1 rounded-full flex items-center gap-1"
                                    style={{
                                        background: `${theme.primary}66`
                                    }}
                                >
                                <span
                                    className="font-semibold"
                                    style={{
                                        color: theme.accent
                                    }}
                                >
                                    {item?.payedExperience}
                                </span>
                                    <CommonIcon icon="xp"/>


                                </div>
                            </RenderIf>
                            <RenderIf cond={item?.payedScore}>
                                <div
                                    className="px-3 py-1 rounded-full flex items-center gap-1"
                                    style={{
                                        background: `${theme.primary}66`
                                    }}
                                >
                                <span
                                    className="font-semibold"
                                    style={{
                                        color: theme.accent
                                    }}
                                >
                                    {item?.payedScore}
                                </span>
                                    <CommonIcon icon="score"/>

                                </div>
                            </RenderIf>
                        </div>

                    </div>

                    {/* Award */}
                    <div
                        className="mt-4 rounded-2xl p-4 flex justify-between items-center"
                        style={{
                            background: `${theme.primary}22`
                        }}
                    >

                        <div className="flex items-center gap-3">

                            <div
                                className="w-14 h-14 rounded-xl overflow-hidden flex items-center justify-center"
                                style={{
                                    background: `${theme.accent}22`,
                                    border: `1px solid ${theme.accent}55`
                                }}
                            >
                                {awardImage ? (
                                    <img
                                        src={awardImage}
                                        alt={award?.title}
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <Trophy
                                        color={theme.accent}
                                        fill={theme.accent}
                                        size={26}
                                    />
                                )}
                            </div>

                            <div>

                                <div className="text-white font-bold text-base">
                                    {award?.title}
                                </div>

                                <div
                                    className="text-xs mt-1"
                                    style={{
                                        color: theme.light
                                    }}
                                >
                                    {isUser
                                        ? "جایزه توسط کاربر دریافت شد"
                                        : "جایزه توسط تیم دریافت شد"}
                                </div>

                            </div>

                        </div>

                        <CheckCircle size={14} color={"#22c55e"}/>

                    </div>

                </div>

            </div>

        </div>
    );

};